import TermsAndPrivacyPage from "./TermsAndPrivacyPage";

export default TermsAndPrivacyPage;